import React from 'react';
import './TableSearch.scss';
import { SearchInput, SearchType } from '../search-input/SearchInput';

export const TableSearch = ({ placeholder, onSearch, searchType }) => (
    <div className={'table-search'}>
        <i className={'material-icons'}>search</i>
        <SearchInput
            placeholder={placeholder}
            searchType={searchType || SearchType.useDebounceOnly}
            onSearch={item => onSearch(item)}
        />
    </div>
);
